import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Typefinders } from '../../core/entities/typefinders.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TypefindersService {
    readonly BASE: any = PETICIONES.typefinders;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los typefinders
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un typefinders por su id
   */
  public findById(id: number): Observable<any> {
    let idtypefinders: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idtypefinders).pipe(delay(DELAY));
  }

   /**
   * @description
   * Guarda un typefinder en la base de datos
   */
  public postTypefinder(typefinders: Typefinders): Observable<any> {
    const json = JSON.stringify(typefinders);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postTypefinders, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un typefinder en la base de datos
   */
  public deleteTypefinder(typefinders: Typefinders): Observable<any> {
    let idtypefinders: string = (typefinders.id !== undefined && typefinders.id !== null ? typefinders.id + "" : "");
    return this.http.get(this.BASE.deleteTypefinders + "/" + idtypefinders).pipe(delay(DELAY));
  }

}